/**
 * Normalizes provider run attributes that may arrive in either camelCase or
 * snake_case form. Returns a stable shape with camelCase keys; missing values
 * become undefined, and a non-object input yields an empty object.
 *
 * @param {Object} [attrs] - Raw providerRunAttributes payload from a run
 * @returns {{
 *   faceLevel: string|undefined,
 *   faceCount: number|undefined,
 *   polygonType: string|undefined,
 *   polyCount: number|undefined,
 *   topology: string|undefined,
 *   materialMode: string|undefined,
 *   generateType: string|undefined,
 *   targetPolycount: number|undefined,
 *   ultraMode: boolean|undefined,
 * }}
 */
export const normalizeRunAttributes = (attrs) => {
  if (!attrs || typeof attrs !== 'object') {
    return {}
  }

  return {
    faceLevel: attrs.faceLevel || attrs.face_level,
    faceCount: attrs.faceCount || attrs.face_count,
    polygonType: attrs.polygonType || attrs.polygon_type,
    polyCount: attrs.polycount || attrs.poly_count,
    topology: attrs.topology,
    materialMode: attrs.materialMode || attrs.material_mode,
    generateType: attrs.generateType || attrs.generate_type,
    targetPolycount: attrs.targetPolycount || attrs.target_polycount,
    // `??` rather than `||`: this one is a boolean, so a stored `false` must not
    // fall through to the snake_case key and come back undefined.
    ultraMode: attrs.ultraMode ?? attrs.ultra_mode,
  }
}
